module.exports = __webpack_public_path__ + "static/media/plan-icon_starter.012ba6cf.svg";